var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClozeTableQuestion = function SvgClozeTableQuestion(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 134,
    viewBox: "0 0 154 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10579_10256)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_10579_10256",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 9.23858 9.23858 7 12 7H142C144.761 7 147 9.23858 147 12V122C147 124.761 144.761 127 142 127H12C9.23857 127 7 124.761 7 122V12Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 9.23858 9.23858 7 12 7H142C144.761 7 147 9.23858 147 12V122C147 124.761 144.761 127 142 127H12C9.23857 127 7 124.761 7 122V12Z",
    fill: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 12C7 2.61116 14.6112 -5 24 -5H130C139.389 -5 147 2.61116 147 12V19C147 19 144.761 19 142 19H12C9.23858 19 7 19 7 19V12ZM147 127H7H147ZM7 127V7V127ZM147 7V127V7Z",
    fill: "#343A40",
    mask: "url(#path-1-inside-1_10579_10256)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 28.5789C15 27.7069 15.7069 27 16.5789 27H53.6667V54H15V28.5789Z",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3333,
    y: 35.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3333,
    y: 35.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    stroke: "#5750FA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 39.5L28.3333 41.5L30.3333 39.5",
    stroke: "#5750FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.6667,
    height: 27,
    transform: "translate(57.6667 27)",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 35.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 35.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    stroke: "#5750FA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 39.5L71 41.5L73 39.5",
    stroke: "#5750FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.333 27H137.421C138.293 27 139 27.7069 139 28.5789V54H100.333V27Z",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.667,
    y: 35.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.667,
    y: 35.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    stroke: "#5750FA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.667 39.5L113.667 41.5L115.667 39.5",
    stroke: "#5750FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.6667,
    height: 27,
    transform: "translate(15 58)",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3333,
    y: 66.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3333,
    y: 66.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    stroke: "#5750FA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 70.5L28.3333 72.5L30.3333 70.5",
    stroke: "#5750FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.6667,
    height: 27,
    transform: "translate(57.6667 58)",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 66.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 66.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    stroke: "#5750FA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 70.5L71 72.5L73 70.5",
    stroke: "#5750FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.6667,
    height: 27,
    transform: "translate(100.333 58)",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.667,
    y: 66.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.667,
    y: 66.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    stroke: "#5750FA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.667 70.5L113.667 72.5L115.667 70.5",
    stroke: "#5750FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 89H53.6667V116H16.5789C15.7069 116 15 115.293 15 114.421V89Z",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3333,
    y: 97.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.3333,
    y: 97.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    stroke: "#5750FA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 101.5L28.3333 103.5L30.3333 101.5",
    stroke: "#5750FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 38.6667,
    height: 27,
    transform: "translate(57.6667 89)",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 97.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 97.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    stroke: "#5750FA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69 101.5L71 103.5L73 101.5",
    stroke: "#5750FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.333 89H139V114.421C139 115.293 138.293 116 137.421 116H100.333V89Z",
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.667,
    y: 97.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.667,
    y: 97.5,
    width: 24,
    height: 10,
    rx: 1.57895,
    stroke: "#5750FA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.667 101.5L113.667 103.5L115.667 101.5",
    stroke: "#5750FA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10579_10256",
    x: 0,
    y: 0,
    width: 154,
    height: 134,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.364706 0 0 0 0 0.494118 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10579_10256"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_10579_10256",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClozeTableQuestion);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTU0IiBoZWlnaHQ9IjEzNCIgdmlld0JveD0iMCAwIDE1NCAxMzQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGZpbHRlcj0idXJsKCNmaWx0ZXIwX2RfMTA1NzlfMTAyNTYpIj4KPG1hc2sgaWQ9InBhdGgtMS1pbnNpZGUtMV8xMDU3OV8xMDI1NiIgZmlsbD0id2hpdGUiPgo8cGF0aCBkPSJNNyAxMkM3IDkuMjM4NTggOS4yMzg1OCA3IDEyIDdIMTQyQzE0NC43NjEgNyAxNDcgOS4yMzg1OCAxNDcgMTJWMTIyQzE0NyAxMjQuNzYxIDE0NC43NjEgMTI3IDE0MiAxMjdIMTJDOS4yMzg1NyAxMjcgNyAxMjQuNzYxIDcgMTIyVjEyWiIvPgo8L21hc2s+CjxwYXRoIGQ9Ik03IDEyQzcgOS4yMzg1OCA5LjIzODU4IDcgMTIgN0gxNDJDMTQ0Ljc2MSA3IDE0NyA5LjIzODU4IDE0NyAxMlYxMjJDMTQ3IDEyNC43NjEgMTQ0Ljc2MSAxMjcgMTQyIDEyN0gxMkM5LjIzODU3IDEyNyA3IDEyNC43NjEgNyAxMjJWMTJaIiBmaWxsPSIjRkRGREZEIi8+CjxwYXRoIGQ9Ik03IDEyQzcgMi42MTExNiAxNC42MTEyIC01IDI0IC01SDEzMEMxMzkuMzg5IC01IDE0NyAyLjYxMTE2IDE0NyAxMlYxOUMxNDcgMTkgMTQ0Ljc2MSAxOSAxNDIgMTlIMTJDOS4yMzg1OCAxOSA3IDE5IDcgMTlWMTJaTTE0NyAxMjdIN0gxNDdaTTcgMTI3VjdWMTI3Wk0xNDcgN1YxMjdWN1oiIGZpbGw9IiMzNDNBNDAiIG1hc2s9InVybCgjcGF0aC0xLWluc2lkZS0xXzEwNTc5XzEwMjU2KSIvPgo8cGF0aCBkPSJNMTUgMjguNTc4OUMxNSAyNy43MDY5IDE1LjcwNjkgMjcgMTYuNTc4OSAyN0g1My42NjY3VjU0SDE1VjI4LjU3ODlaIiBmaWxsPSIjRTlFQ0VGIi8+CjxyZWN0IHg9IjIyLjMzMzMiIHk9IjM1LjUiIHdpZHRoPSIyNCIgaGVpZ2h0PSIxMCIgcng9IjEuNTc4OTUiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHg9IjIyLjMzMzMiIHk9IjM1LjUiIHdpZHRoPSIyNCIgaGVpZ2h0PSIxMCIgcng9IjEuNTc4OTUiIHN0cm9rZT0iIzU3NTBGQSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTI2LjMzMzMgMzkuNUwyOC4zMzMzIDQxLjVMMzAuMzMzMyAzOS41IiBzdHJva2U9IiM1NzUwRkEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHJlY3Qgd2lkdGg9IjM4LjY2NjciIGhlaWdodD0iMjciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU3LjY2NjcgMjcpIiBmaWxsPSIjRTlFQ0VGIi8+CjxyZWN0IHg9IjY1IiB5PSIzNS41IiB3aWR0aD0iMjQiIGhlaWdodD0iMTAiIHJ4PSIxLjU3ODk1IiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB4PSI2NSIgeT0iMzUuNSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjEwIiByeD0iMS41Nzg5NSIgc3Ryb2tlPSIjNTc1MEZBIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNNjkgMzkuNUw3MSA0MS41TDczIDM5LjUiIHN0cm9rZT0iIzU3NTBGQSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAwLjMzMyAyN0gxMzcuNDIxQzEzOC4yOTMgMjcgMTM5IDI3LjcwNjkgMTM5IDI4LjU3ODlWNTRIMTAwLjMzM1YyN1oiIGZpbGw9IiNFOUVDRUYiLz4KPHJlY3QgeD0iMTA3LjY2NyIgeT0iMzUuNSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjEwIiByeD0iMS41Nzg5NSIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMTA3LjY2NyIgeT0iMzUuNSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjEwIiByeD0iMS41Nzg5NSIgc3Ryb2tlPSIjNTc1MEZBIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMTExLjY2NyAzOS41TDExMy42NjcgNDEuNUwxMTUuNjY3IDM5LjUiIHN0cm9rZT0iIzU3NTBGQSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cmVjdCB3aWR0aD0iMzguNjY2NyIgaGVpZ2h0PSIyNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTUgNTgpIiBmaWxsPSIjRTlFQ0VGIi8+CjxyZWN0IHg9IjIyLjMzMzMiIHk9IjY2LjUiIHdpZHRoPSIyNCIgaGVpZ2h0PSIxMCIgcng9IjEuNTc4OTUiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHg9IjIyLjMzMzMiIHk9IjY2LjUiIHdpZHRoPSIyNCIgaGVpZ2h0PSIxMCIgcng9IjEuNTc4OTUiIHN0cm9rZT0iIzU3NTBGQSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTI2LjMzMzMgNzAuNUwyOC4zMzMzIDcyLjVMMzAuMzMzMyA3MC41IiBzdHJva2U9IiM1NzUwRkEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHJlY3Qgd2lkdGg9IjM4LjY2NjciIGhlaWdodD0iMjciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU3LjY2NjcgNTgpIiBmaWxsPSIjRTlFQ0VGIi8+CjxyZWN0IHg9IjY1IiB5PSI2Ni41IiB3aWR0aD0iMjQiIGhlaWdodD0iMTAiIHJ4PSIxLjU3ODk1IiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB4PSI2NSIgeT0iNjYuNSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjEwIiByeD0iMS41Nzg5NSIgc3Ryb2tlPSIjNTc1MEZBIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNNjkgNzAuNUw3MSA3Mi41TDczIDcwLjUiIHN0cm9rZT0iIzU3NTBGQSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cmVjdCB3aWR0aD0iMzguNjY2NyIgaGVpZ2h0PSIyNyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTAwLjMzMyA1OCkiIGZpbGw9IiNFOUVDRUYiLz4KPHJlY3QgeD0iMTA3LjY2NyIgeT0iNjYuNSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjEwIiByeD0iMS41Nzg5NSIgZmlsbD0id2hpdGUiLz4KPHJlY3QgeD0iMTA3LjY2NyIgeT0iNjYuNSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjEwIiByeD0iMS41Nzg5NSIgc3Ryb2tlPSIjNTc1MEZBIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNMTExLjY2NyA3MC41TDExMy42NjcgNzIuNUwxMTUuNjY3IDcwLjUiIHN0cm9rZT0iIzU3NTBGQSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTUgODlINTMuNjY2N1YxMTZIMTYuNTc4OUMxNS43MDY5IDExNiAxNSAxMTUuMjkzIDE1IDExNC40MjFWODlaIiBmaWxsPSIjRTlFQ0VGIi8+CjxyZWN0IHg9IjIyLjMzMzMiIHk9Ijk3LjUiIHdpZHRoPSIyNCIgaGVpZ2h0PSIxMCIgcng9IjEuNTc4OTUiIGZpbGw9IndoaXRlIi8+CjxyZWN0IHg9IjIyLjMzMzMiIHk9Ijk3LjUiIHdpZHRoPSIyNCIgaGVpZ2h0PSIxMCIgcng9IjEuNTc4OTUiIHN0cm9rZT0iIzU3NTBGQSIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTI2LjMzMzMgMTAxLjVMMjguMzMzMyAxMDMuNUwzMC4zMzMzIDEwMS41IiBzdHJva2U9IiM1NzUwRkEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHJlY3Qgd2lkdGg9IjM4LjY2NjciIGhlaWdodD0iMjciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDU3LjY2NjcgODkpIiBmaWxsPSIjRTlFQ0VGIi8+CjxyZWN0IHg9IjY1IiB5PSI5Ny41IiB3aWR0aD0iMjQiIGhlaWdodD0iMTAiIHJ4PSIxLjU3ODk1IiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB4PSI2NSIgeT0iOTcuNSIgd2lkdGg9IjI0IiBoZWlnaHQ9IjEwIiByeD0iMS41Nzg5NSIgc3Ryb2tlPSIjNTc1MEZBIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8cGF0aCBkPSJNNjkgMTAxLjVMNzEgMTAzLjVMNzMgMTAxLjUiIHN0cm9rZT0iIzU3NTBGQSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAwLjMzMyA4OUgxMzlWMTE0LjQyMUMxMzkgMTE1LjI5MyAxMzguMjkzIDExNiAxMzcuNDIxIDExNkgxMDAuMzMzVjg5WiIgZmlsbD0iI0U5RUNFRiIvPgo8cmVjdCB4PSIxMDcuNjY3IiB5PSI5Ny41IiB3aWR0aD0iMjQiIGhlaWdodD0iMTAiIHJ4PSIxLjU3ODk1IiBmaWxsPSJ3aGl0ZSIvPgo8cmVjdCB4PSIxMDcuNjY3IiB5PSI5Ny41IiB3aWR0aD0iMjQiIGhlaWdodD0iMTAiIHJ4PSIxLjU3ODk1IiBzdHJva2U9IiM1NzUwRkEiIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxwYXRoIGQ9Ik0xMTEuNjY3IDEwMS41TDExMy42NjcgMTAzLjVMMTE1LjY2NyAxMDEuNSIgc3Ryb2tlPSIjNTc1MEZBIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZF8xMDU3OV8xMDI1NiIgeD0iMCIgeT0iMCIgd2lkdGg9IjE1NCIgaGVpZ2h0PSIxMzQiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQ29sb3JNYXRyaXggaW49IlNvdXJjZUFscGhhIiB0eXBlPSJtYXRyaXgiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMTI3IDAiIHJlc3VsdD0iaGFyZEFscGhhIi8+CjxmZU9mZnNldC8+CjxmZUdhdXNzaWFuQmx1ciBzdGREZXZpYXRpb249IjMuNSIvPgo8ZmVDb21wb3NpdGUgaW4yPSJoYXJkQWxwaGEiIG9wZXJhdG9yPSJvdXQiLz4KPGZlQ29sb3JNYXRyaXggdHlwZT0ibWF0cml4IiB2YWx1ZXM9IjAgMCAwIDAgMC4zNjg2MjcgMCAwIDAgMCAwLjM2NDcwNiAwIDAgMCAwIDAuNDk0MTE4IDAgMCAwIDAuMzUgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvd18xMDU3OV8xMDI1NiIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvd18xMDU3OV8xMDI1NiIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K";